/*
 * Page Name
 */

(function ($) {

    var btn_copy_address = $('.copy_address');
    if (btn_copy_address.length > 0) {
        btn_copy_address.on('click', function () {
            if (jQuery(this).hasClass('_copy1')) {
                jQuery("#f_zipcode1").val(jQuery("#f_zipcode").val());
                jQuery("#f_address1").val(jQuery("#f_address").val());
                jQuery("#f_phone1").val(jQuery("#f_phone").val());
            }
            if (jQuery(this).hasClass('_copy2')) {
                jQuery("#f_zipcode2").val(jQuery("#f_zipcode").val());
                jQuery("#f_address2").val(jQuery("#f_address").val());
                jQuery("#f_phone2").val(jQuery("#f_phone").val());
            }
        });
    }

    /*entryform*/

    jQuery.datepicker.regional['ja'] = {
        monthNames: ["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"],
        monthNamesShort: ["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"],
        dayNames: ["日曜日","月曜日","火曜日","水曜日","木曜日","金曜日","土曜日"],
        dayNamesShort: ["日","月","火","水","木","金","土"],
        dayNamesMin: ["日","月","火","水","木","金","土"],
        weekHeader: "週",
        dateFormat: "yy/mm/dd",
        firstDay: 0,
        isRTL: false,
        showMonthAfterYear: true,
        yearSuffix: "年"
    };
    jQuery.datepicker.setDefaults(jQuery.datepicker.regional['ja']);  // Apply Japanese localization globally

    jQuery("#datepicker").datepicker({
        dateFormat: "yy年mm月dd日",
        changeMonth: true,
        changeYear: true,
        defaultDate: '-25y',
        yearRange: "-100:+0",
    });

    jQuery('#entry_f_zipcode').zip2addr({
        pref: '#entry_f_prefecture',
        addr: '#entry_f_address'
    })

    var form_btn_prev = $('.wpcf7-previous.btn');
    if (form_btn_prev.length > 0) {
        form_btn_prev.on('click', function (e) {
            // t.hasOwnProperty(r) && "" != t[r] ? window.location.href = t[r] : t.hasOwnProperty(i) && "" != t[i] ? window.location.href = t[i] : window.history.go(-1), e.preventDefault()
            e.preventDefault();
            window.history.go(-1);
        });
    }

})(jQuery);